import { AuthService } from './../../auth/auth-service.service';
import { NbToastrService } from '@nebular/theme';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CurrentUserService } from '../current-user.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ReloadOnChangeComponent } from '../../reload-on-change.component';

@Component({
  selector: 'ngx-user-logo',
  templateUrl: './user-logo.component.html',
  styleUrls: ['./user-logo.component.scss']
})
export class UserLogoComponent extends ReloadOnChangeComponent {
  popupVisible: boolean = false;
  value: any[] = [];
  uploadUrl: string;
  uploadHeader: any;

  allowCreate: boolean = false;

  customerLogoUrl: SafeUrl;
  uploadPhotoOptions: any;
  showLogo: boolean = false;


  constructor(private toastrService: NbToastrService, private authService: AuthService, private currentUserService: CurrentUserService, private sanitizer: DomSanitizer) {
    super(currentUserService);
    this.uploadUrl = environment.API_URL + "klantlogo/upload";
    this.uploadHeader = { "Authorization": "Bearer " + localStorage.getItem("id_token") }

    //this.customerLogoUrl = environment.API_URL + "klantlogo";
    this.allowCreate = authService.userHasClaim('KlantLogoCreate');

    const that = this;

    this.uploadPhotoOptions = {
      text: 'Logo uploaden',
      onClick(e) {
        that.hide();
      }
    };

  }

  override ngOnInit(): void {
    this.loadData();
    super.ngOnInit()
  }

  override loadData(): void {
    this.loadLogo();
  }

  show() {
    this.loadLogo();
    this.popupVisible = true;
  }

  hide() {
    this.popupVisible = false;
  }

  loadLogo() {
    this.currentUserService.getActiveCustomer().subscribe(customer => {
      if (customer?.HeefKlantLogo) {
        this.currentUserService.getCustomerLogo().subscribe((data) => {
          this.customerLogoUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
          this.showLogo = true;
        }, (error) => {
          this.customerLogoUrl = null;
          this.showLogo = false;
          if (error.status !== 404) this.toastrService.warning('De foto kan niet worden weergegeven, neem contact op met de beheerder', 'Fout');
        })
      } else {
        this.customerLogoUrl = null;
        this.showLogo = false;
      }
    });
  }

  fileUploaded(event): void {
    var image = event.request.response;
    event.component.reset();
    this.toastrService.success('Logo is succesvol geupload', 'Gelukt!');
    this.loadLogo();
  }
}
